import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { useTranslation } from "react-i18next";
import { useDietContext } from "@/contexts/DietContext";
import { Button } from "@/components/ui/button";

export const BasicInfoStep = () => {
    const { t } = useTranslation();
    const { formData, setFormData, setStep } = useDietContext();

    const handleInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const onNextStep = () => {
        setStep((prev) => prev + 1);
    };

    const onBackStep = () => {
        setStep((prev) => prev - 1);
    };

    return (
        <div className="space-y-6 max-w-2xl mx-auto">
            <div className="text-center mb-12">
                <h1 className="text-3xl font-bold text-gray-900 mb-4">
                    {t("buildDiet.basicInfo.title")}
                </h1>
            </div>
            <div className="space-y-4">
                <div>
                    <Label htmlFor="age">{t("buildDiet.basicInfo.age")}</Label>
                    <Input
                        id="age"
                        name="age"
                        type="number"
                        min="18"
                        max="100"
                        value={formData.age}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                <div>
                    <Label htmlFor="height">
                        {t("buildDiet.basicInfo.height")} (cm)
                    </Label>
                    <Input
                        id="height"
                        name="height"
                        type="number"
                        min="140"
                        max="220"
                        value={formData.height}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                <div>
                    <Label htmlFor="weight">
                        {t("buildDiet.basicInfo.weight")} (kg)
                    </Label>
                    <Input
                        id="weight"
                        name="weight"
                        type="number"
                        min="40"
                        max="200"
                        value={formData.weight}
                        onChange={handleInputChange}
                        required
                    />
                </div>

                <div className="space-y-2">
                    <Label>{t("buildDiet.basicInfo.gender")}</Label>
                    <RadioGroup
                        onValueChange={(value) =>
                            setFormData((prev) => ({ ...prev, sex: value }))
                        }
                        className="flex space-x-4"
                    >
                        <div className="flex items-center space-x-2">
                            <RadioGroupItem value="male" id="male" />
                            <Label htmlFor="male">
                                {t("buildDiet.basicInfo.male")}
                            </Label>
                        </div>
                        <div className="flex items-center space-x-2">
                            <RadioGroupItem value="female" id="female" />
                            <Label htmlFor="female">
                                {t("buildDiet.basicInfo.female")}
                            </Label>
                        </div>
                    </RadioGroup>
                </div>

                {/* Pulsanti Back e Next */}
                <div>&nbsp;</div>
                <div className="max-w-2xl mx-auto flex justify-between pt-4 border-t border-gray-800 ">
                    <Button variant="outline" onClick={onBackStep}>
                        {t("buildDiet.back")}
                    </Button>
                    <Button
                        onClick={onNextStep}
                        disabled={
                            !formData.age ||
                            !formData.height ||
                            !formData.weight ||
                            !formData.sex
                        }
                    >
                        {t("buildDiet.next")}
                    </Button>
                </div>
            </div>
        </div>
    );
};
